module.exports = __webpack_public_path__ + "static/media/WorkSans-Regular.6f916ce8.ttf";